import { useMutation, UseMutationResult } from 'react-query';
import { inviteUserToAccount, InviteUserToAccountRequest } from '../api/usersApi';

export const useInviteUserToAccount = (): UseMutationResult<
  void,
  unknown,
  InviteUserToAccountRequest,
  unknown
> => {
  return useMutation(['users'], (params: InviteUserToAccountRequest) => inviteUserToAccount(params));
};

export default useInviteUserToAccount;
